<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="top-list-toolbar">
          <div>
            <h4 class="text-primary">Product</h4>
            <ol class="breadcrumb breadcrumb-card-header">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);" @click="backParent">Product</a>
              </li>
              <li class="breadcrumb-item active">
                <!-- <span v-if="product.id === null">New</span> -->
                <!-- <span v-else>{{ product.product_name }}</span> -->
              </li>
            </ol>
            <button type="button" @click="backParent" class="btn btn-sm btn-hard-outline-primary pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
            <button type="button" @click="updateProduct" class="btn btn-sm btn-soft-primary pull-left" v-show="product.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
            <button type="button" @click="createProduct" class="btn btn-sm btn-soft-primary pull-left" v-show="product.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
          </div>
        </div>
      </div>
    </div>
    <div class="card card-list">
      <div class="card-header">
        <div class="col-md-12">
          <h5 class="text-primary">
            <span v-if="product.id === null">New</span>
            <span v-else>{{ product.product_no }} - {{ product.product_name }}</span>
          </h5>
          <i class="fa fa-cart-plus" aria-hidden="true"></i> On Hand Quantity: {{ product.onHandQty }} - {{ product.uom_id }}
        </div>
      </div>
      <div class="card-body">
        <ul class="nav nav-tabs nav-bordered">
            <li class="nav-item">
              <a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">
                General
              </a>
            </li>
            <li class="nav-item">
              <a href="#uom-list" data-toggle="tab" aria-expanded="true" class="nav-link">
                UoM
              </a>
            </li>
            <li class="nav-item" v-show="product.is_variant === true" >
              <a href="#variant-list" data-toggle="tab" aria-expanded="true" class="nav-link">
                Variant
              </a>
            </li>
            <li class="nav-item">
              <a href="#price-list" data-toggle="tab" aria-expanded="true" class="nav-link">
                Price List
              </a>
            </li>
            <li class="nav-item" v-show="product.type_id === 'Storable Product'">
              <a href="#product-purchasing" data-toggle="tab" aria-expanded="true" class="nav-link">
                Purchasing
              </a>
            </li>
            <li class="nav-item" v-show="product.type_id === 'Storable Product'">
              <a href="#onhand-list" data-toggle="tab" aria-expanded="true" class="nav-link">
                Stock Quantity
              </a>
            </li>
            <li class="nav-item" >
              <a href="#costs-list" data-toggle="tab" aria-expanded="true" class="nav-link">
                COGS
              </a>
            </li>
            <li class="nav-item">
              <a href="#account-list" data-toggle="tab" aria-expanded="true" class="nav-link">
                Account
              </a>
            </li>
            <li class="nav-item">
              <a href="#package" data-toggle="tab" aria-expanded="true" class="nav-link">Package</a>
            </li>
        </ul>
        <div class="tab-content">
            <div class="tab-pane active" id="general">
                <div class="row">
                  <div class="col-md-4 container-center">
                    <div id="product-img-border" @click="chooseFiles">
                      <img :src="`${publicPath}asset/img/product.png`" id="product-img" class="ml-auto" v-if="product.photo === null">
                      <img :src="product.photo" id="product-img" class="ml-auto" v-else/>
                      <input type="file" id="file" ref="file" @change="handleFileUpload()" hidden/>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group row">
                      <label for="product_name" class="col-sm-3 col-form-label text-left">Name</label>
                      <div class="col-sm-9">
                        <input class="form-control" type="text" id="product_name" v-model="product.product_name"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="product_no" class="col-sm-3 col-form-label text-left">Product No</label>
                      <div class="col-sm-9">
                          <input class="form-control" type="text" id="product_no" v-model="product.product_no" placeholder="[Auto number]"/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="product_description" class="col-sm-3 col-form-label text-left">Internal Code</label>
                      <div class="col-sm-9">
                        <input class="form-control" type="text" id="barcode" v-model="product.barcode"/>
                      </div>
                    </div>
                    <div class="form-group row">
                          <label for="type_id" class="col-sm-3 col-form-label text-left">Product Type</label>
                          <div class="col-sm-9">
                            <select v-model="product.type_id" id="type_id" class="form-control" @change="setAcc">
                                  <option v-for="t in productTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                              </select>
                          </div>
                      </div>
                      <div class="form-group row">
                          <label for="category_id" class="col-sm-3 col-form-label text-left">Product Category</label>
                          <div class="col-sm-9">
                              <select v-model="product.category_id" id="category_id" class="form-control">
                                  <option v-for="c in productCategoryList" :key="c.id" :value="c.id">{{ c.name }}</option>
                              </select>
                          </div>
                      </div>
                      <div class="form-group row">
                        <label for="uom_id" class="col-sm-3 col-form-label text-left">Unit Of Measure</label>
                        <div class="col-sm-9">
                          <select v-model="product.uom_id" id="uom_id" class="form-control">
                            <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name}}</option>
                          </select>
                        </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group row">
                      <label for="price" class="col-sm-3 col-form-label text-left">Price</label>
                      <div class="col-sm-9">
                        <input class="form-control" type="text" id="price" v-model="product.price" v-money="money" disabled="disabled" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="cost" class="col-sm-3 col-form-label text-left">Cost</label>
                      <div class="col-sm-9">
                        <p class="input-group">
                            <input class="form-control" type="text" id="cost" v-model="product.cost" v-money="money" disabled="disabled" v-if="product.costing_method !== 'Standard Price'"/>
                            <input class="form-control" type="text" id="cost" v-model="product.cost" v-money="money" v-else/>
                            <span class="input-group-btn ml-1">
                              <button type="button" class="btn btn-primary" v-if="product.costing_evaluation === 'Manual'" @click="setCost">Set</button>
                            </span>
                        </p>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="uom_id" class="col-sm-3 col-form-label text-left">Costing Method</label>
                      <div class="col-sm-9">
                        <select v-model="product.costing_method" id="costing_method" class="form-control">
                          <option value="Standard Price">Standard Price</option>
                          <option value="First In First Out(FIFO)">First In First Out(FIFO)</option>
                          <option value="Average Cost">Average Cost</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="uom_id" class="col-sm-3 col-form-label text-left">Cost Evaluation</label>
                      <div class="col-sm-9">
                        <select v-model="product.costing_evaluation" id="costing_evaluation" class="form-control">
                          <option value="Automatic">Automatic</option>
                          <option value="Manual">Manual</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="qty_total" class="col-sm-3 col-form-label text-left">Qty Total</label>
                      <div class="col-sm-9">
                        <div class="row">
                          <div class="col-md-7">
                            <input type="text" class="form-control" v-model="product.qty_total"/>
                          </div>
                          <div class="col-md-2">
                            <button type="button" class="btn btn-sm btn-primary">Recalculate</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                        <label for="canBarcode" class="col-sm-3 col-form-label text-left"></label>
                        <div class="col-sm-9">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" id="canBarcode" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="product.canBarcode">
                            <label for="canBarcode" class="custom-control-label">Item Have Serial Number</label>
                          </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="is_variant" class="col-sm-3 col-form-label text-left"></label>
                        <div class="col-sm-9">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" id="is_variant" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="product.is_variant">
                            <label for="is_variant" class="custom-control-label">Variant</label>
                          </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="active" class="col-sm-3 col-form-label text-left"></label>
                        <div class="col-sm-9">
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" id="active" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="product.active">
                            <label for="active" class="custom-control-label">Active</label>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-md-12">
                    <h4>Description:</h4>
                    <div class="form-group row">
                      <div class="col-sm-12">
                        <textarea rows="10" class="form-control" id="product_description" v-model="product.product_description"/>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <div class="tab-pane" id="product-purchasing">
              <table class="table table-sm table-item">
                <thead>
                    <th>Vendor</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Date</th>
                    <th></th>
                </thead>
                <tbody>
                  <tr v-for="pp in productPurchasingFilter" :key="pp.id">
                      <td>{{ pp.vendor_no }} - {{ pp.vendor }}</td>
                      <td>{{ pp.minimum_quantity }}</td>
                      <td>{{ pp.amount }}</td>
                      <td>{{ pp.start_date | dateFormat('DD/MM/YYYY') }}</td>
                      <td>
                          <button
                          type="button"
                          class="btn btn-hard-outline-primary btn-sm"
                          @click="editVendor(pp.id)"
                          data-toggle="modal"
                          data-target="#modalGetProductPurchasing"
                          data-backdrop="static"
                          data-keyboard="false">
                              <i class="fa fa-pencil" aria-hidden="true"></i>
                          </button>
                          <button type="button" class="btn btn-soft-outline-danger btn-sm" @click="removeVendor(pp.id)" data-toggle="tooltip" data-placement="bottom" title="Delete vendor purchasing">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                          </button>
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <a href='#' class="link-secondary" data-toggle="modal" data-target="#modalGetProductPurchasing" data-backdrop="static" data-keyboard="false" @click="addNewLine">
                            Add Line
                          </a>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="tab-pane" id="price-list">
              <table class="table table-sm table-item">
                <thead>
                  <th>Group</th>
                  <th>Qty</th>
                  <th>Unit</th>
                  <th>Price</th>
                  <th>Date</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="pl in priceListFilter" :key="pl.id">
                      <td><b>{{ pl.group }}</b></td>
                      <td>{{ pl.quantity }}</td>
                      <td>{{ pl.uom_id }}</td>
                      <td>{{ pl.price }}</td>
                      <td>{{ pl.start_date | dateFormat('DD/MM/YYYY') }}</td>
                      <td>
                          <button
                          type="button"
                          class="btn btn-outline-info btn-sm"
                          @click="editPriceList(pl.id)"
                          data-toggle="modal"
                          data-target="#modalGetPriceList"
                          data-backdrop="static"
                          data-keyboard="false">
                              <i class="fa fa-pencil" aria-hidden="true"></i>
                          </button>
                          <button type="button" class="btn btn-outline-primary btn-sm" @click="removePriceList(pl.id)" data-toggle="tooltip" data-placement="bottom" title="Delete vendor purchasing">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                          </button>
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <a href='#' class="link-secondary" data-toggle="modal" data-target="#modalGetPriceList" data-backdrop="static" data-keyboard="false"  @click="addNewPriceList">
                            Add Line
                          </a>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                  </tr>
                </tbody>
              </table>
              <!-- <pre>{{ priceListFilter}}</pre> -->
            </div>

            <div class="tab-pane" id="onhand-list">
              <table class="table table-sm table-item">
                <thead>
                  <th>Product No.</th>
                  <th>Product SKU</th>
                  <th>Qty</th>
                  <th>Unit</th>
                  <th>Price</th>
                  <th>Date</th>
                  <th>Warehouse</th>
                  <th>Notes</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="ol in onHandListFilter" :key="ol.id">
                      <td><b>{{ ol.product_no }}</b></td>
                      <td v-if="ol.product_sku !== null"><b>{{ ol.product_sku }}</b></td>
                      <td v-else><b>-</b></td>
                      <td>{{ ol.qty }}</td>
                      <td>{{ ol.uom_id }}</td>
                      <td>{{ ol.price }}</td>
                      <td>{{ ol.on_hand_date | dateFormat('DD/MM/YYYY') }}</td>
                      <td>{{ ol.warehouse }}</td>
                      <td>{{ ol.notes }}</td>
                      <td>
                          <button
                          type="button"
                          class="btn btn-outline-info btn-sm"
                          @click="editOnHand(ol.id)"
                          data-toggle="modal"
                          data-target="#modalGetOnHand"
                          data-backdrop="static"
                          data-keyboard="false">
                              <i class="fa fa-pencil" aria-hidden="true"></i>
                          </button>
                      </td>
                  </tr>
                  <tr>
                      <td>
                          <a href='#' class="link-secondary" data-toggle="modal" data-target="#modalGetOnHand" data-backdrop="static" data-keyboard="false" @click="addNewOnHand">
                            Add On Hand
                          </a>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Costs -->
            <div class="tab-pane" id="costs-list">
              <ProductCostlist :costs="product.costs" :product="product.product_no" @backCost="backCost"/>
              <!-- <table class="table table-sm table-item table-hover">
                <thead>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Ref No.</th>
                  <th>Qty</th>
                  <th>Uom</th>
                  <th>Price</th>
                  <th>Cost(Average)</th>
                </thead>
                <tbody>
                  <tr v-for="ct in costFilter" :key="ct.id">
                    <td>
                      <span class="badge badge-success" v-if="ct.status === 'purchasing'">{{ ct.status }}</span>
                      <span class="badge badge-warning" v-else-if="ct.status === 'sales'">{{ ct.status }}</span>
                      <span class="badge badge-primary" v-else>{{ ct.status }}</span>
                    </td>
                    <td>{{ ct.cost_date | dateFormat('DD/MM/YYYY') }}</td>
                    <td>{{ ct.ref_no }}</td>
                    <td>{{ ct.cost_qty }}</td>
                    <td>{{ ct.uom_id }}</td>
                    <td>{{ ct.cost_amount | currency }}</td>
                    <td>{{ ct.cost_average | currency }}</td>
                  </tr>
                  <tr>
                    <td>
                      <span style="cursor: pointer; color: blue;" @click="addNewCost">Add Line</span>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table> -->
            </div>
            <div class="tab-pane" id="account-list">
              <table class="table table-sm table-item">
                <thead>
                  <th>Account</th>
                  <th>Type</th>
                  <th>Description</th>
                  <th>Company</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="(ac, index) in accountFilter" :key="ac.id">
                    <td>
                      <v-select :options="getAccountList" :reduce="account => account.meta.code" label="account" v-model="ac.account_code"/>
                    </td>
                    <td>
                      <select v-model="ac.type_id" class="form-control">
                        <option v-for="at in productAccounTypeList" :key="at.id" :value="at.id">{{ at.name }}</option>
                      </select>
                    </td>
                    <td>
                      <input type="text" v-model="ac.description" class="form-control"/>
                    </td>
                    <td>
                      <select v-model="ac.company_no" class="form-control">
                        <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                      </select>
                    </td>
                    <td>
                      <button type="button" class="btn btn-danger btn-sm" @click="removeAccount(index)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                      <td>
                          <span class="link-secondary" @click="addAccount">
                            Add Account
                          </span>
                      </td>
                      <td></td>
                      <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane" id="variant-list">
              <table class="table table-sm table-item">
                <thead>
                  <th>Variant</th>
                  <th>Product SKU</th>
                  <th>Name</th>
                  <th>#</th>
                </thead>
                <tbody>
                  <tr v-for="(pv, index) in product.variants" :key="pv.id">
                    <td>
                      <select v-model="pv.variant_id" class="form-control" @change="setVariantSku(index)">
                        <option v-for="v in variantList" :key="v.id" :value="v.id">{{ v.name }}</option>
                      </select>
                    </td>
                    <td><input type="text" class="form-control" v-model="pv.product_sku"></td>
                    <td><input type="text" class="form-control" v-model="pv.name" /></td>
                    <td>
                      <button type="button" class="btn btn-outline-primary btn-sm" @click="removeVariantList(pv.id)" data-toggle="tooltip" data-placement="bottom" title="Delete vendor purchasing">
                          <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                      <td>
                          <a href='javascript:void(0)' class="link-secondary" @click="addNewVariantList">
                            Add Line
                          </a>
                      </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane" id="uom-list">
              <table class="table table-sm table-item">
                <thead>
                  <th>Product No</th>
                  <th>UoM</th>
                  <th>Convert Type</th>
                  <th>Ratio</th>
                  <th><center>Status</center></th>
                  <th>#</th>
                </thead>
                <tbody>
                  <tr v-for="pu in product.uoms" :key="pu.id">
                    <td><input type="text" class="form-control" v-model="pu.product_no" disabled/></td>
                    <td>
                      <select v-model="pu.uom_id" class="form-control">
                        <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name }}</option>
                      </select>
                    </td>
                    <td>
                      <select v-model="pu.category_id" class="form-control">
                        <option v-for="c in uomCategoryList" :key="c.id" :value="c.id">{{ c.name }}</option>
                      </select>
                    </td>
                    <td><input type="number" min="1" class="form-control" v-model="pu.ratio"/></td>
                    <td><input type="checkbox" class="form-control" v-model="pu.active"/></td>
                    <td>
                      <button type="button" class="btn btn-outline-primary btn-sm" @click="removeUomList(pu.id)" data-toggle="tooltip" data-placement="bottom" title="Delete vendor purchasing">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                      <td>
                          <a href='javascript:void(0)' class="link-secondary" @click="addNewUomList">
                            Add Line
                          </a>
                      </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="tab-pane" id="package">
              <table class="table table-sm table-item">
                <thead>
                  <th>Product</th>
                  <th>Name</th>
                  <th>Qty</th>
                  <th>Uom</th>
                  <th>price</th>
                  <th>Variant</th>
                  <th>Serial Number</th>
                  <th>#</th>
                </thead>
                <tbody>
                  <tr v-for="(p, index) in product.packages" :key="p.id">
                    <td>
                      <p class="input-group">
                          <input type="text" class="form-control" v-model="p.product_no" disabled="disabled" />
                          <span class="input-group-btn ml-1">
                            <button data-toggle="modal" data-target="#modalGetProduct" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-soft-primary btn-sm" @click="setIdPackageList(index)"><i class="fa fa-search" aria-hidden="true"></i></button>
                          </span>
                      </p>
                    </td>
                    <td><input type="text" class="form-control" v-model="p.name" /></td>
                    <td><input type="text" class="form-control" v-model="p.qty" /></td>
                    <td>
                      <select v-model="p.uom_id" id="uom_id" class="form-control">
                        <option v-for="u in uomList" :key="u.id" :value="u.id">{{ u.name}}</option>
                      </select>
                    </td>
                    <td><input type="text" class="form-control" v-model="p.price" v-money="money"/></td>
                    <td><input type="text" class="form-control" v-model="p.product_sku" /></td>
                    <td><input type="text" class="form-control" v-model="p.serial_number" /></td>
                    <td>
                      <button type="button" class="btn btn-sm btn-soft-outline-primary" @click="removePackage(index)"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a href='javascript:void(0)' class="link-secondary" @click="addNewPackage">Add Line</a>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
      </div>
      <div class="card-footer">
      </div>
    </div>
    <ProductModal @setProductPurhasing="getVendorPurchasing" :product="product" :id="idVendor" :state="state"/>
    <ProductModalPrice :product="product" :id="idPl" :state="state"/>
    <ProductModalOnHand :product="product" :id="idOH" :state="state"/>
    <ProductModalBarcode :product="product" :id="idBC" :state="state"/>
    <ProductModalVariant :product="product" :id="idPV" :state="state"/>
    <PurchasingProductModal :idDetail="idPackageList" @selectProduct="selectProduct" :type="'regular'"/>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { productUrl, priceListUrl, productVariantUrl, productPurchasingUrl, getHeader } from '@/config'
import ProductModal from '@/components/product/ProductModal.vue'
import ProductModalPrice from '@/components/product/ProductModalPrice.vue'
import ProductModalOnHand from '@/components/product/ProductModalOnHand.vue'
import ProductModalBarcode from '@/components/product/ProductModalBarcode.vue'
import ProductModalVariant from '@/components/product/ProductModalVariant.vue'
import PurchasingProductModal from '@/components/purchasing/PurchasingProductModal.vue'
import ProductCostlist from '@/components/product/ProductCostList.vue'

export default {
  name: 'PurchasingForm',
  props: ['product'],
  components: {
    ProductModal,
    ProductModalPrice,
    ProductModalOnHand,
    ProductModalBarcode,
    ProductModalVariant,
    PurchasingProductModal,
    ProductCostlist
  },
  data () {
    return {
      idPackageList: null,
      publicPath: process.env.BASE_URL,
      idBC: null,
      idPl: null,
      idVendor: null,
      idOH: null,
      idPV: null,
      state: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      productCategoryList: state => state.products.productCategoryList,
      productTypeList: state => state.products.productTypeList,
      uomList: state => state.uom.uomList,
      accountList: state => state.accounts.accountList,
      productAccounTypeList: state => state.products.productAccounTypeList,
      variantList: state => state.variants.variantList,
      companyList: state => state.companies.companyList,
      uomCategoryList: state => state.uom.uomCategoryList
    }),
    getAccountList: function () {
      var array = this.accountList
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          account: '[' + array[i].account_code + '] ' + array[i].account_name,
          meta: {
            code: array[i].account_code
          }
        }
        loop.push(obj)
      }
      return loop
    },
    accountFilter: function () {
      return this.product.accounts.filter(d => d.id !== null)
    },
    productPurchasingFilter: function () {
      return this.product.productPurchasing.filter(d => d.id !== null)
    },
    priceListFilter: function () {
      return this.product.priceList.filter(d => d.id !== null)
    },
    onHandListFilter: function () {
      return this.product.onHand.filter(d => d.id !== null)
    },
    costFilter: function () {
      return this.product.costs.filter(d => d.id !== null)
    }
  },
  methods: {
    backCost () {
      this.$emit('backID', this.product.id)
    },
    removePackage: function (index) {
      var pckg = this.product.packages[index]
      if (typeof pckg.id === 'undefined') {
        this.product.packages.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(productUrl + '/package/' + pckg.id, { headers: getHeader() })
              .then(response => {
                this.product.packages.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
              })
          }
        })
      }
    },
    selectProduct: function (value) {
      var pckg = this.product.packages[this.idPackageList]
      pckg.product_id = this.product.id
      pckg.product_no = value.product_no
      pckg.name = value.product_name
      pckg.price = null
      pckg.valid_date = null
      pckg.qty = 1
      pckg.product_sku = value.product_sku
      pckg.serial_number = null
      pckg.uom_id = value.uom_id
      pckg.uomList = value.uomList
    },
    setIdPackageList: function (index) {
      this.$store.dispatch('getProductByVariant')
      this.idPackageList = index
    },
    addNewPackage: function () {
      var obj = {
        product_id: this.product.id,
        product_no: null,
        name: null,
        price: null,
        valid_date: null,
        qty: 1,
        product_sku: null,
        serial_number: null,
        uom_id: null
      }
      this.product.packages.push(obj)
    },
    setVariantSku: function (index) {
      var variant = this.product.variants[index]
      const vari = this.variantList.find(d => d.id === variant.variant_id)
      variant.product_sku = this.product.product_no + '_' + vari.name
      variant.name = this.product.product_name + ' ' + vari.name
    },
    chooseFiles: function () {
      document.getElementById('file').click()
    },
    async handleFileUpload () {
      this.file = this.$refs.file.files[0]
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('product_no', this.product.product_no)
      formData.append('type', 'header')
      const newHeader = {
        'Content-Type': 'multipart/form-data'
      }
      const newObj = Object.assign(getHeader(), newHeader)
      console.log(productUrl + '/photo')
      await axios.post(productUrl + '/photo', formData, { headers: newObj })
        .then(response => {
          console.log(response.data.data)
          this.product.photo = response.data.data.url
          // this.employee.profiles = response.data.data.url
          // this.$toasted.show(response.data.message, {
          //   theme: 'toasted-primary',
          //   position: 'top-right',
          //   duration: 5000,
          //   icon: 'check',
          //   type: 'success'
          // })
        })
        .catch(error => {
          console.log(error.response)
          this.$toasted.show(error.response.data.message, {
            theme: 'toasted-primary',
            position: 'top-right',
            duration: 5000,
            icon: 'check',
            type: 'error'
          })
        })
    },
    addNewCost: function () {
      var obj = {
        product_no: null,
        ref_no: null,
        cost_amount: '0',
        cost_qty: null,
        cost_average: '0',
        cost_date: null,
        uom_id: null,
        status: 'purchasing'
      }
      this.product.costs.push(obj)
    },
    async setCost () {
      if (this.product.id !== null) {
        await axios.put(productUrl + '/' + this.product.id, this.product, { headers: getHeader() })
          .then(response => {
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
          })
        await axios.get(productUrl + '/cost/' + this.product.id, { headers: getHeader() })
          .then(response => {
            console.log(response.data.data)
            this.product.cost = response.data.data.cost
          })
          .catch(error => {
            console.log(error.response)
          })
      } else {
        this.$swal(
          'Error',
          'Cannot set cost',
          'error'
        )
      }
    },
    removeAccount: function (index) {
      var detail = this.product.accounts[index]
      if (typeof detail.id === 'undefined') {
        this.product.accounts.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(productUrl + '/account/' + detail.id, { headers: getHeader() })
              .then(response => {
                this.product.accounts.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
                this.$swal(
                  'Error',
                  error.response.data.message,
                  'error'
                )
              })
          }
        })
      }
    },
    addAccount: function () {
      var obj = {
        product_no: this.product.product_no,
        account_code: null,
        description: null,
        type_id: null
      }
      this.product.accounts.push(obj)
    },
    backParent: function () {
      this.$emit('backClicked')
    },
    async updateProduct () {
      await axios.put(productUrl + '/' + this.product.id, this.product, { headers: getHeader() })
        .then(response => {
          var msg = response.data.message
          var array = this.product.uoms
          var productNo = response.data.data.product_no
          for (let i = 0; i < array.length; i++) {
            var data = {
              product_no: productNo,
              uom_id: array[i].uom_id,
              ratio: array[i].ratio,
              active: array[i].active,
              category_id: array[i].category_id
            }
            if (array[i].id) {
              axios.put(productUrl + '/uom/' + array[i].id, data, { headers: getHeader() })
                .then(response => {
                })
                .catch(error => {
                  console.log(error.response)
                  this.$swal('Error', error.response.data.message, 'error')
                })
            } else {
              axios.post(productUrl + '/uom', data, { headers: getHeader() })
                .then(response => {
                })
                .catch(error => {
                  console.log(error.response)
                  this.$swal('Error', error.response.data.message, 'error')
                })
            }
          }

          this.$swal(
            'Product',
            msg,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          // Validate Product Name
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
          return false
        })
      await this.$emit('backSaveClicked')
    },
    async createProduct () {
      await axios.post(productUrl, this.product, { headers: getHeader() })
        .then(response => {
          var msg = response.data.message
          var array = this.product.uoms
          var productNo = response.data.data.product_no
          for (let i = 0; i < array.length; i++) {
            var data = {
              product_no: productNo,
              uom_id: array[i].uom_id,
              ratio: array[i].ratio,
              active: array[i].active,
              category_id: array[i].category_id
            }
            axios.post(productUrl + '/uom', data, { headers: getHeader() })
              .then(response => {
              })
              .catch(error => {
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
              })
          }

          this.$swal(
            'Product',
            msg,
            'success'
          )
          this.$emit('backSaveClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    },
    getVendorPurchasing (value) {
      this.product.productPurchasing.push(value)
    },
    editVendor (id) {
      this.idVendor = id
      this.state = 'edit'
    },
    removeVendor (id) {
      this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          var index = this.product.productPurchasing.findIndex(d => d.id === id)
          this.product.productPurchasing.splice(index, 1)
          axios.delete(productPurchasingUrl + '/' + id, { headers: getHeader() })
            .then(response => {
              this.$swal(
                'Successfully!!',
                'Deleted',
                'success'
              )
            })
            .catch(response => {
              console.log(response)
            })
        }
      })
    },
    addNewLine: function () {
      // var newID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      var newID = Math.floor(Math.random() * (999999 - 666666) + 666666)
      this.idVendor = newID
      this.product.productPurchasing.push({
        id: newID,
        product_no: null,
        vendor_no: null,
        vendor: null,
        minimum_quantity: 1,
        amount: 0,
        start_date: null,
        end_date: null
      })
      this.state = 'create'
    },
    addNewPriceList: function () {
      var newID = Math.floor(Math.random() * (999999 - 666666) + 666666)
      this.idPl = newID
      this.product.priceList.push({
        id: newID,
        group_id: 1,
        group: null,
        product_no: null,
        quantity: 1,
        price: 0,
        start_date: null,
        end_date: null
      })
      this.state = 'create'
    },
    editPriceList: function (id) {
      this.idPl = id
      this.state = 'edit'
    },
    addNewVariantList: function () {
      this.product.variants.push({
        product_no: this.product.product_no,
        product_sku: null,
        name: null,
        variant_id: null,
        variant: null
      })
      this.state = 'create'
    },
    editVariantList: function (id) {
      this.idPV = id
      this.state = 'edit'
    },
    removeVariantList: function (id) {
      this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          var index = this.product.variants.findIndex(d => d.id === id)
          this.product.variants.splice(index, 1)
          axios.delete(productVariantUrl + '/' + id, { headers: getHeader() })
            .then(response => {
              this.$swal(
                'Successfully!!',
                'Deleted',
                'success'
              )
            })
            .catch(response => {
              console.log(response)
            })
        }
      })
    },
    addNewUomList: function () {
      this.product.uoms.push({
        product_no: this.product.product_no,
        uom_id: 'pcs',
        category_id: null,
        ratio: 0,
        active: true
      })
      this.state = 'create'
    },
    editUomList: function (id) {
      this.idPU = id
      this.state = 'edit'
    },
    removeUomList: function (id) {
      this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          var index = this.product.uoms.findIndex(d => d.id === id)
          this.product.uoms.splice(index, 1)
          axios.delete(productUrl + '/uom/' + id, { headers: getHeader() })
            .then(response => {
              this.$swal(
                'Successfully!!',
                'Deleted',
                'success'
              )
            })
            .catch(response => {
              console.log(response)
            })
        }
      })
    },
    addNewOnHand: function () {
      var newID = Math.floor(Math.random() * (9999999999 - 6666666666) + 6666666666)
      this.idOH = newID
      this.product.onHand.push({
        id: newID,
        product_no: this.product.product_no,
        product_sku: this.product.product_sku,
        qty: null,
        price: '0',
        on_hand_date: null,
        notes: null,
        warehouse_no: null,
        branch_no: null,
        uom_id: null,
        adjust_no: null,
        serial_number: null,
        sec_serial_number: null,
        internal_no: null
      })
      this.state = 'create'
    },
    editOnHand: function (id) {
      this.idOH = id
      this.state = 'edit'
    },
    removePriceList: function (id) {
      this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          var index = this.product.priceList.findIndex(d => d.id === id)
          this.product.priceList.splice(index, 1)
          axios.delete(priceListUrl + '/' + id, { headers: getHeader() })
            .then(response => {
              this.$swal(
                'Successfully!!',
                'Deleted',
                'success'
              )
            })
            .catch(response => {
              console.log(response)
            })
        }
      })
    },
    addNewBarcode: function () {
      var newID = Math.floor(Math.random() * (9999999999 - 6666666666) + 6666666666)
      this.idBC = newID
      this.product.barcodes.push({
        id: newID,
        product_no: this.product.product_no,
        barcode: null,
        vendor_no: null,
        vendor: null
      })
      this.state = 'create'
    },
    editBarcode: function (id) {
      this.idBC = id
      this.state = 'edit'
    },
    removeBarcode: function (id) {
      this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          var index = this.product.barcodes.findIndex(d => d.id === id)
          axios.delete(productUrl + '/barcode/' + id, { headers: getHeader() })
            .then(response => {
              this.$swal(
                'Successfully!!',
                'Deleted',
                'success'
              )
              this.product.barcodes.splice(index, 1)
            })
            .catch(response => {
              console.log(response)
            })
        }
      })
    },
    async setAcc () {
      this.product.accounts = []
      await axios.get(productUrl + '/type/' + this.product.type_id, { headers: getHeader() })
        .then(response => {
          var array = response.data.data.accounts
          if (array) {
            for (let i = 0; i < array.length; i++) {
              var obj = {
                account_code: array[i].account_code,
                type_id: array[i].type_id,
                description: array[i].description,
                company_no: array[i].company_no
              }
              this.product.accounts.push(obj)
            }
          }
        })
        .catch(error => {
          console.log(error.message)
        })
    }
  }
}
</script>

<style>
.container-center {
  /* margin: 25px; */
  /* width: 350px; */
  /* height: 200px; */
  /* outline: dashed 1px black; */
  /* Center vertically and horizontally */
  display: flex;
  justify-content: center;
  align-items: center;
}
#product-img-border {
  /* position: absolute; */
  border: 2px solid #b7b7b7;
  width: 300px;
  height: 300px;
  background-color: #fff;
  padding: 10px;
  cursor: pointer;
  /* padding: 10px;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 0; */
}
#product-img {
  width: 280px;
  height: 280px;
  object-fit: cover;
  /* left: 50%; */
  /* margin: -25px 0 0 -25px; */
}
</style>
